module.exports = __webpack_public_path__ + "static/media/id-int-icon.86a68806.svg";